import { render, staticRenderFns } from "./choiceArea.vue?vue&type=template&id=75554f2b&"
import script from "./choiceArea.vue?vue&type=script&lang=js&"
export * from "./choiceArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports